/**
 * Utility functions for handling Community Modal events
 * This file contains helper functions to manage communication between components
 * related to the Community Modal and its various sub-modals
 */

/**
 * Open the Community Modal with specified parameters
 * 
 * @param {Object} params - Configuration parameters
 * @param {number} params.tabIndex - Tab index to open (0 = Friends, 1 = User Finder, 2 = Messages)
 * @param {boolean} params.openSendMessage - Whether to open the send message modal
 * @param {string} params.recipientId - The recipient ID to pre-fill in the message modal
 */
export const openCommunityModal = (params = {}) => {
  const event = new CustomEvent('openCommunityModal', {
    detail: {
      tabIndex: params.tabIndex || 1,
      openSendMessage: params.openSendMessage || false,
      recipientId: params.recipientId || null
    }
  });
  
  document.dispatchEvent(event);
};

/**
 * Open the Send Message Modal directly with a specified recipient
 * 
 * @param {string} recipientId - The recipient ID to pre-fill 
 */
export const openSendMessageModal = (recipientId) => {
  openCommunityModal({
    tabIndex: 2, // Messages tab
    openSendMessage: true,
    recipientId
  });
};

/**
 * Open the Feedback Modal with pre-filled values for reporting a user message
 * 
 * @param {Object} reportData - Report information
 * @param {string} reportData.senderName - The name of the user being reported
 * @param {string} reportData.messageId - The ID of the message being reported
 */
export const openReportMessageModal = (reportData) => {
  console.log('openReportMessageModal called with data:', reportData);
  
  const event = new CustomEvent('openReportModal', {
    detail: {
      subject: "Report user message",
      message: `I would like to report a message from user ${reportData.senderName}.\n\nMessage ID: ${reportData.messageId}\nTime: ${new Date().toLocaleString()}\n\nPlease provide additional details about why you're reporting this message:`,
      isReport: true
    }
  });
  
  console.log('Dispatching openReportModal event with detail:', event.detail);
  document.dispatchEvent(event);
  console.log('Event dispatched');
};

const communityModalEvents = {
  openCommunityModal,
  openSendMessageModal,
  openReportMessageModal
};

export default communityModalEvents;
